import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/scss/index.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LicenseInfo } from "@mui/x-license-pro";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import "freyads/freyadesignsystem.css";
import "./locals";
import i18n from "./locals";
import { useConfigStore } from "./store/config";
import { SnackbarUtilsConfigurator } from "./component/NotistackPlus";
import { initAcTenantIdFromQuery } from "./utils/tenant";

initAcTenantIdFromQuery();

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string);
const queryClient = new QueryClient();

useConfigStore.subscribe(
  (state) => state.language,
  (language) => {
    i18n.changeLanguage(language);
  }
);

// if (process.env.NODE_ENV === "development") {
//   const { worker } = require("./mocks/browser");
//   worker.start({ onUnhandledRequest: "bypass" });
// }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <SnackbarProvider
    maxSnack={1}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
  >
    <SnackbarUtilsConfigurator />
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </SnackbarProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
